export const fluidCouplingSelection = [
    {
        motorRanking: 2.2,
        models: ['FB0.85C', 'FB0.85C', 'FB0.85C', 'FB0.85C'],       // 1800rpm(4Px60Hz), 1200rpm(6Px60Hz), 1500rpm(4Px50Hz), 1000rpm(6Px50Hz)
        
    },
    {
        motorRanking: 3.7,
        models: ['FB0.85C', 'FB0.85C', 'FB0.85C', 'FB0.85C'],
        
    },
    {
        motorRanking: 5.5,
        models: ['FB0.85C', 'FB0.85C', 'FB0.85C', 'FB0.85C'],
        
    },
    {
        motorRanking: 7.5,
        models: ['FB0.85C', 'FB0.85C', 'FB0.85C', 'FB0.85C'],
        
    },
    {
        motorRanking: 11,
        models: ['FB0.85C', 'FB0.85C', 'FB0.85C', 'FB0.85C'],
        
    },
    {
        motorRanking: 15,
        models: ['FB0.85C', 'FB0.85C', 'FB0.85C', 'FB0.85C'],
        
    },
    {
        motorRanking: 18.5,
        models: ['FB0.85C', 'FB0.85C', 'FB0.85C', 'FB0.85C'],
        
    },
    {
        motorRanking: 22,
        models: ['FB0.85C', 'FB0.85C', 'FB0.85C', 'FB0.85C'],
        
    },
    {
        motorRanking: 30,
        models: ['FB0.85C', 'FB0.85C', 'FB0.85C', 'FB0.85C'],
        
    },
    {
        motorRanking: 37,
        models: ['FB0.85C', 'FB0.85C', 'FB0.85C', 'FB0.85C'],
        
    },
    {
        motorRanking: 45,
        models: ['FB0.85C', 'FB0.85C', 'FB0.85C', 'FB0.85C'],
        
    },
    {
        motorRanking: 55,
        models: ['FB0.85C', 'FB0.85C', 'FB0.85C', 'FB1.0D'],
        
    },
    {
        motorRanking: 75,
        models: ['FB0.85C', 'FB0.85C', 'FB0.85C', 'FB1.0D'],
        
    },
    {
        motorRanking: 90,
        models: ['FB1.0D', 'FB1.0D', 'FB0.85C', 'FB1.0D'],
        
    },
    {
        motorRanking: 110,
        models: ['FB1.0D', 'FB1.0D', 'FB0.85C', 'FB1.2C'],
        
    },
    {
        motorRanking: 132,
        models: ['FB1.0D', 'FB1.0D', 'FB0.85C', 'FB1.2C'],
        
    },
    {
        motorRanking: 150,
        models: ['FB1.2C', 'FB1.2C', 'FB0.85C', 'FB1.2C'],
        
    },
    {
        motorRanking: 160,
        models: ['FB1.2C', 'FB1.2C', 'FB0.85C', 'FB1.2C'],
        
    },
    {
        motorRanking: 185,
        models: ['FB1.2C', 'FB1.2C', 'FB1.0D', 'FB1.2C'],
        
    },
    {
        motorRanking: 200,
        models: ['FB1.2C', 'FB1.2C', 'FB1.0D', 'FB1.2C'],
        
    },
    {
        motorRanking: 220,
        models: ['FB1.2C', 'FB1.2C', 'FB1.0D', 'FB1.2C'],
        
    },
    {
        motorRanking: 250,
        models: ['FB1.2C', 'FB1.2C', 'FB1.0D', 'FB1.5D'],
        
    },
    {
        motorRanking: 280,
        models: ['FB1.2C', 'FB1.2C', 'FB1.0D', 'FB1.5D'],
        
    },
    {
        motorRanking: 300,
        models: ['FB1.2C', 'FB1.2C', 'FB1.0D', 'FB1.5D'],
        
    },
    {
        motorRanking: 315,
        models: ['FB1.2C', 'FB1.2C', 'FB1.0D', 'FB1.5D'],
        
    },
    {
        motorRanking: 355,
        models: ['FB1.5D', 'FB1.5D', 'FB1.5D', 'FB1.5D'],
        
    },
    {
        motorRanking: 375,
        models: ['FB1.5D', 'FB1.5D', 'FB1.5D', 'FB1.5D'],
        
    },
    {
        motorRanking: 400,
        models: ['FB1.5D', 'FB1.5D', 'FB1.5D', 'FB1.5D'],
        
    },
    {
        motorRanking: 450,
        models: ['FB1.5D', 'FB1.5D', 'FB1.5D', 'FB1.7D'],
        
    },
    {
        motorRanking: 500,
        models: ['FB1.5D', 'FB1.5D', 'FB1.5D', 'FB1.7D'],   
        
    },
];


export const fluidCouplingData = [
    {
        model: 'FB0.85C',
        inertia: 22.4,          // 데이터 없어서 유사값 임의 입력
        weight: 102.5,
    },
    {
        model: 'FB1.0D',
        inertia: 53.4,          // 데이터 없어서 유사값 임의 입력
        weight: 145.0,
    },
    {
        model: 'FB1.2C',
        inertia: 150.0,         // 데이터 없어서 유사값 임의 입력
        weight: 292.5,
    },
    {
        model: 'FB1.5D',
        inertia: 221.0,         // 데이터 없어서 유사값 임의 입력
        weight: 366.0,
    },
    {
        model: 'FB1.7D',
        inertia: 464.0,         //kg-m2     // 데이터 없어서 유사값 임의 입력
        weight: 575.0,          // kg
    },
];